module.exports = __webpack_public_path__ + "fonts/WorkSans-ExtraBold.bd9d1bc.eot";